import React from 'react'
import BaaHam_NormalUsers_AgahiBox from '../BaaHam_NormalUsers_AgahiBox'
import './BaaHam_NormalUsers_Favorites.css'

function BaaHam_NormalUsers_Favorites() {
  return (
    <div className='BaaHam_NormalUsers_Favorites'>
        <BaaHam_NormalUsers_AgahiBox/>
        <BaaHam_NormalUsers_AgahiBox/>
    </div>
  )
}

export default BaaHam_NormalUsers_Favorites